import * as AllColors from "../constants/colors";

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createAnchorNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createBasicTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createBottomDrawerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createBusinesscardAuthorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createBusinesscardContactMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALTROSA"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KERZENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Schwarz";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Brillantkarmin";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_INDIABLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Brillantkarmin";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createCardTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createCardTeaserOffsetMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createCarouselMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createColorSeparatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createContactBarMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createContactLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createContentAggregatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createContentAggregatorItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createDataTableMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALTROSA"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KERZENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_INDIABLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createDividerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALTROSA"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KERZENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_INDIABLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createErrorMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALTROSA"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KERZENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_INDIABLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createFooterBarMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createImageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createMapMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createMapInfoLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createMultiContentStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createNumberMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createOffsetTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createOffsetTeaser5MapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createPageHeaderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createPageHeaderCircleMapDefinition() {
  let obj = {};
  return obj;
}
export function createPictogramMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createPromoFlagMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Arktisgruen";
  obj[AllColors["COLOR_SCHWARZ"]] = "Arktisgruen";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Arktisgruen";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Dahliengelb";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Arktisgruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Arktisgruen";
  obj[AllColors["COLOR_ALTROSA"]] = "Arktisgruen";
  obj[AllColors["COLOR_KERZENGELB"]] = "Arktisgruen";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Arktisgruen";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Arktisgruen";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Arktisgruen";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Arktisgruen";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Arktisgruen";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Arktisgruen";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Arktisgruen";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Arktisgruen";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Arktisgruen";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Arktisgruen";
  obj["default"] = "Arktisgruen";
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createSectionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createSitelinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createSliderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createSpacerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createStepMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createTableRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createTextTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createThirdLevelNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createThirdLevelNavigationItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createTilesTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALTROSA"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KERZENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_INDIABLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createVideoplayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALTROSA"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KERZENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Schwarz";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Brillantkarmin";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_INDIABLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Brillantkarmin";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createViolatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createSearchResultItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createTabsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createClickableImageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALTROSA"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KERZENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Schwarz";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Brillantkarmin";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_INDIABLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Brillantkarmin";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createReadMoreMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALTROSA"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KERZENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Schwarz";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Brillantkarmin";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_INDIABLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Brillantkarmin";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createAnswerCardMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALTROSA"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KERZENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_INDIABLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createAnswerCardGroupMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALTROSA"]] = "Quartzgrau10";
  obj[AllColors["COLOR_KERZENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Quartzgrau10";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Quartzgrau10";
  obj[AllColors["COLOR_INDIABLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Quartzgrau10";
  return obj;
}
export function createBadgeMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createBreadcrumbMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createBulletListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createBulletListDeprecatedMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createCaptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createContactListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createDateEventMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Red";
  obj[AllColors["COLOR_SCHWARZ"]] = "Red";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Red";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Red";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Red";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Red";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Red";
  obj[AllColors["COLOR_ALTROSA"]] = "Red";
  obj[AllColors["COLOR_KERZENGELB"]] = "Red";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Red";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Red";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Red";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Red";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Red";
  obj[AllColors["COLOR_INDIABLAU"]] = "Red";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Red";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Red";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Red";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Red";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Red";
  obj["default"] = "Red";
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createStepsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createTagPillMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALTROSA"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KERZENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Schwarz";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Brillantkarmin";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_INDIABLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Brillantkarmin";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createCompassMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_SCHWARZ"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALTROSA"]] = "Brillantkarmin";
  obj[AllColors["COLOR_KERZENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Schwarz";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Brillantkarmin";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Brillantkarmin";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Brillantkarmin";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_INDIABLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Brillantkarmin";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Brillantkarmin";
  obj["default"] = "Brillantkarmin";
  return obj;
}
export function createListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createChipMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createPaginationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createImageGalleryItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createImageGalleryOverviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createImageGalleryPreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createBackgroundMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createBadgesMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createCheckboxGroupMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createFormMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createGridControlMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "bright";
  obj[AllColors["COLOR_SCHWARZ"]] = "Schwarz";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Orientgelb";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Fasergruen";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Arktisgruen";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Bischofsrot";
  obj[AllColors["COLOR_ALTROSA"]] = "Altrosa";
  obj[AllColors["COLOR_KERZENGELB"]] = "Kerzengelb";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Brillantkarmin";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Erdbeerrot";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Verkehrsorange";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Dahliengelb";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Leuchtendgruen";
  obj[AllColors["COLOR_INDIABLAU"]] = "Indiablau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Alpenblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Quartzgrau10";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Quartzgrau20";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Quartzgrau50";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Quartzgrau75";
  obj["default"] = "bright";
  return obj;
}
export function createMtCaptchaMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createPageWrapperMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createRadioButtonGroupMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createTabNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createTagPillGroupMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Schwarz";
  obj[AllColors["COLOR_SCHWARZ"]] = "bright";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Schwarz";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Schwarz";
  obj[AllColors["COLOR_ALTROSA"]] = "Schwarz";
  obj[AllColors["COLOR_KERZENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "bright";
  obj[AllColors["COLOR_ERDBEERROT"]] = "bright";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "bright";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Schwarz";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Schwarz";
  obj[AllColors["COLOR_INDIABLAU"]] = "Schwarz";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Schwarz";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "bright";
  obj["default"] = "Schwarz";
  return obj;
}
export function createPictogramBoxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
export function createStickyBannerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "Karibikblau";
  obj[AllColors["COLOR_SCHWARZ"]] = "Karibikblau";
  obj[AllColors["COLOR_ORIENTGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_FASERGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_ARKTISGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_KARIBIKBLAU"]] = "Fasergruen";
  obj[AllColors["COLOR_BISCHOFSROT"]] = "Karibikblau";
  obj[AllColors["COLOR_ALTROSA"]] = "Karibikblau";
  obj[AllColors["COLOR_KERZENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_BRILLANTKARMIN"]] = "Karibikblau";
  obj[AllColors["COLOR_ERDBEERROT"]] = "Karibikblau";
  obj[AllColors["COLOR_VERKEHRSORANGE"]] = "Karibikblau";
  obj[AllColors["COLOR_DAHLIENGELB"]] = "Karibikblau";
  obj[AllColors["COLOR_LEUCHTENDGRUEN"]] = "Karibikblau";
  obj[AllColors["COLOR_INDIABLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_ALPENBLAU"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU10"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU20"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU50"]] = "Karibikblau";
  obj[AllColors["COLOR_QUARTZGRAU75"]] = "Karibikblau";
  obj["default"] = "Karibikblau";
  return obj;
}
